import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { api } from 'src/services';

type Practitioner = {
  ehr_id: string;
  first_name: string;
  is_shown: boolean;
  last_name: string;
  org_uuid: string;
  practitioner_email: string;
  practitioner_id: number;
  title: string;
};

type GetPractitionerByEhrIdResponse = {
  practitioner: Practitioner;
};

export const useGetPractitionerByEhrId = (
  ehrProviderId: string | undefined,
  {
    enabled = true,
    ...options
  }: Omit<
    UseQueryOptions<GetPractitionerByEhrIdResponse, unknown>,
    'queryKey' | 'queryFn'
  > = {}
) => {
  return useQuery<GetPractitionerByEhrIdResponse, unknown>({
    queryKey: ['practitioner', 'ehr', ehrProviderId],
    queryFn: () =>
      api
        .get<GetPractitionerByEhrIdResponse>(
          `/v2/practitioners/ehr/${ehrProviderId}`
        )
        .then((res) => res.data),
    enabled: !!ehrProviderId && enabled,
    ...options,
  });
};
